var map = {
	"./apple-touch-icon-retina.png": 1696,
	"./apple-touch-icon.png": 1697,
	"./chatdesk-logo.png": 1698,
	"./chatdesk_video_thumbnail.png": 724,
	"./check-mark.png": 1699,
	"./delighted.png": 1700,
	"./facebook.png": 682,
	"./favicon16.png": 1701,
	"./favicon32.png": 1702,
	"./favicon48.png": 1703,
	"./front.png": 685,
	"./gladly.png": 1704,
	"./gorgias.png": 1705,
	"./helpscout.png": 686,
	"./icon_business.png": 235,
	"./icon_gladly.png": 725,
	"./icon_gorgias.png": 726,
	"./icon_lock.png": 1706,
	"./icon_reamaze.png": 727,
	"./icon_shopify.png": 728,
	"./icon_status_green.png": 729,
	"./icon_status_red.png": 730,
	"./icon_status_yellow.png": 731,
	"./icon_twitter.png": 1707,
	"./icons/icon_thumbs_up.png": 732,
	"./instagram.png": 683,
	"./kustomer.png": 733,
	"./live_agent.png": 1708,
	"./logos/logo_dixa.png": 506,
	"./logos/logo_reamaze.png": 336,
	"./logos/logo_tiktok_shop.png": 507,
	"./no-image-rect.png": 1709,
	"./no-image.png": 1710,
	"./profile_pic_grace.png": 1711,
	"./profile_pic_tara.png": 734,
	"./reamaze.png": 1712,
	"./salesforce_service_cloud.png": 1713,
	"./shopify.png": 1714,
	"./skin/database_add.png": 1715,
	"./skin/database_delete.png": 1716,
	"./skin/database_edit.png": 1717,
	"./skin/database_save.png": 1718,
	"./skin/database_table.png": 1719,
	"./skin/exclamation.png": 1720,
	"./skin/house.png": 1721,
	"./skin/information.png": 1722,
	"./stamped.png": 1723,
	"./tick.png": 1724,
	"./tiktok.png": 687,
	"./twitter.png": 681,
	"./yotpo.png": 1725,
	"./zendesk-chat.png": 735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1695;